(() => {
  'use strict';
  if (window.G21PremiumPriceCard?.installed) return;

  const labels = {
    tr: 'İNDİRİM',
    en: 'OFF',
    fr: 'RÉDUCTION',
    de: 'RABATT',
    es: 'DESCUENTO',
    nl: 'KORTING',
    ar: 'خصم',
    ru: 'СКИДКА'
  };

  const parseMoney = (text) => {
    let value = String(text || '').replace(/\s+/g, '').replace(/[^0-9,.-]/g, '');
    if (!value) return NaN;
    const comma = value.lastIndexOf(',');
    const dot = value.lastIndexOf('.');
    const decimalIndex = Math.max(comma, dot);
    if (comma >= 0 && dot >= 0) {
      const decimal = comma > dot ? ',' : '.';
      const thousands = decimal === ',' ? /\./g : /,/g;
      value = value.replace(thousands, '').replace(decimal, '.');
    } else if (decimalIndex >= 0) {
      const digitsAfter = value.length - decimalIndex - 1;
      if (digitsAfter === 2) {
        value = value.replace(decimalIndex === comma ? ',' : '.', '.');
      } else {
        value = value.replace(/[,.]/g, '');
      }
    }
    return Number(value);
  };

  const enhance = (priceComponent) => {
    try {
      if (!(priceComponent instanceof Element)) return false;
      const sale = priceComponent.querySelector('.price__sale:not(.price__hidden)');
      if (!sale) return false;

      const salePrice = sale.querySelector('.price-item--sale');
      const comparePrice = sale.querySelector('.compare-at-price');
      const saleGroup = salePrice?.closest('.price-item__group');
      const compareGroup = comparePrice?.closest('.price-item__group');
      if (!salePrice || !comparePrice || !saleGroup || !compareGroup) return false;

      let secondary = sale.querySelector(':scope > .g21-price-secondary');
      if (!secondary) {
        secondary = document.createElement('span');
        secondary.className = 'g21-price-secondary';
        sale.appendChild(secondary);
      }
      if (compareGroup.parentElement !== secondary) secondary.prepend(compareGroup);

      const current = parseMoney(salePrice.textContent);
      const original = parseMoney(comparePrice.textContent);
      const percentage = Number.isFinite(current) && Number.isFinite(original) && original > current
        ? Math.max(1, Math.round(((original - current) / original) * 100))
        : 0;

      let badge = secondary.querySelector('.g21-discount-percentage');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'g21-discount-percentage';
        secondary.appendChild(badge);
      }

      const language = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
      const badgeText = percentage ? `${percentage}% ${labels[language] || labels.en}` : '';
      const badgeHidden = !percentage;

      if (badge.textContent !== badgeText) badge.textContent = badgeText;
      if (badge.hidden !== badgeHidden) badge.hidden = badgeHidden;
      if (!sale.classList.contains('g21-premium-price-ready')) {
        sale.classList.add('g21-premium-price-ready');
      }
      return true;
    } catch (error) {
      console.warn('[G21 price card] Native Shopify price remains active:', error);
      return false;
    }
  };

  const observe = (component) => {
    if (!(component instanceof Element) || component.dataset.g21PremiumPriceObserved === 'true') return;
    component.dataset.g21PremiumPriceObserved = 'true';

    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      queueMicrotask(() => {
        queued = false;
        if (!component.isConnected) {
          observer.disconnect();
          return;
        }
        enhance(component);
      });
    });

    observer.observe(component, { childList: true, subtree: true });
  };

  const scan = (root = document) => {
    try {
      const components = new Set(
        root.querySelectorAll?.('[data-testid="product-information"] product-price, .g21-product-page product-price') || []
      );
      if (root instanceof Element && root.matches('product-price')) components.add(root);

      components.forEach((component) => {
        enhance(component);
        observe(component);
      });
    } catch (error) {
      console.warn('[G21 price card] Enhancement skipped; native Shopify price remains active:', error);
    }
  };

  const start = () => scan(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => scan(event.target));

  window.G21PremiumPriceCard = Object.freeze({
    installed: true,
    refresh: () => scan(document)
  });
})();
